/**
 * Quick add from a product card.
 *
 * The card's foot bar is a real <form> posting to /cart/add, so it works with
 * JavaScript off. This upgrades it to an AJAX add and reports back on the
 * button itself.
 *
 * With the bag on the page it hands the add to `DDJCart.add` (assets/cart.js),
 * which opens the bag at once and fills it from one request; the bag shows
 * any refusal (sold out, no more stock). Without it, the older route: add,
 * read cart.js, dispatch `cart:change` with the new cart in `detail` and
 * update the header's `[data-cart-count]`; on failure `cart:error` with
 * Shopify's message, or the real form post.
 *
 * Delegated from document, so cards rendered later (a section re-render in the
 * theme editor, a paginated collection) need no re-binding.
 */
(function () {
  if (window.__ddjProductCardBound) return;
  window.__ddjProductCardBound = true;

  var RESET_AFTER = 2000;

  // Shopify only defines the routes object on a storefront that has it, and
  // markets prefix it. Same guard `search-drawer.js` uses.
  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function updateCartCount(cart) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (node) {
      // The bag link reads "BAG (0)". Swap only the number in the brackets so
      // the label stays whatever the locale file says it is.
      node.textContent = node.textContent.replace(/\((\d+)\)/, '(' + cart.item_count + ')');
    });
  }

  /* The look of each state is CSS (src/input.css, Loading states): a
   * hairline while adding, the plus swapped for the check once added. */
  function setState(button, state) {
    /* A second add while the first still says Added: its reset must not land
     * in the middle of this one. */
    if (state === 'adding') clearTimeout(button._ddjReset);
    button.setAttribute('data-state', state);
    button.disabled = state === 'adding';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-quick-add]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('[data-quick-add-button]');
    if (button && button.disabled) return;

    if (button) setState(button, 'adding');

    if (window.DDJCart && window.DDJCart.add) {
      window.DDJCart.add(new FormData(form)).then(function () {
        if (!button) return;
        setState(button, 'added');
        button._ddjReset = setTimeout(function () {
          setState(button, 'idle');
        }, RESET_AFTER);
      }, function (error) {
        if (button) setState(button, 'idle');
        /* No message from Shopify (offline): the real form post instead. */
        if (!(error && error.description)) form.submit();
      });
      return;
    }

    fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form),
    })
      .then(function (response) {
        if (response.ok) return fetch(root() + 'cart.js');
        return response.json().then(
          function (body) { throw { description: body && (body.description || body.message), status: response.status }; },
          function () { throw { status: response.status }; }
        );
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));

        if (!button) return;
        setState(button, 'added');
        button._ddjReset = setTimeout(function () {
          setState(button, 'idle');
        }, RESET_AFTER);
      })
      .catch(function (error) {
        if (button) setState(button, 'idle');
        // The bag drawer shows Shopify's own message (sold out, no more
        // stock). Without one, fall back to the real form post so the
        // customer is never stuck.
        if (document.querySelector('[data-cart-drawer]') && error && error.description) {
          document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: error.description, source: 'product-card' } }));
          return;
        }
        form.submit();
      });
  });
})();
